import { CommonModule } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../Model/Common/common.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { UtilityService } from '../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { SessionService } from '../Util/Session/session.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserMasterService } from '../user-master.service';
import { ComboService } from '../Model/Combo/combo.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-user-master',
  standalone: true,
  imports: [CommonModule, LoaderComponent, FormsModule, NgSelectModule, DataTablesModule, RouterModule],
  templateUrl: './user-master.component.html',
  styleUrl: './user-master.component.scss'
})
export class UserMasterComponent {

  // activeModal = inject(NgbActiveModal);
  dtoptions: DataTables.Settings = {};
  constructor(
    public common: CommonService,
    private utility: UtilityService,
    private toast: ToastService,
    private session: SessionService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private userMasterService: UserMasterService,
    private comboload: ComboService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe((params: { [x: string]: string; }) => this.Detail.UserMasterId = parseInt(params['id']));
    this.dtoptions = { ...this.common.commonDToptions };
  }

  async ngOnInit() {
    await this.ComboLoadAsync('ProfileMaster');
    await this.ComboLoadAsync('EmpMapping');
    await this.ComboLoadAsync('CompanyMaster');
    await this.ComboLoadAsync('FnFUserType');
    this.chunkOtherModule();
    if (this.Detail.UserMasterId > 0) {
      this.GetData()
    }
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  isDisabled: boolean = false;
  user = [] as any;
  // OtherModule = [
  //   { ID: 'Paymax', Name: "Paymax", checked: false },
  //   { ID: 'Online Registration', Name: "Online Registration", checked: false },
  //   { ID: 'Max Financial', Name: "Max Financial", checked: false },
  //   { ID: 'Online Attendance', Name: "Online Attendance", checked: false },
  //   { ID: 'Compliance', Name: "Compliance", checked: false },
  //   { ID: 'Web Ess', Name: "Web Ess", checked: false },
  //   { ID: 'Highlighter', Name: "Highlighter", checked: false },
  //   { ID: 'Client Portal', Name: "Client Portal", checked: false },
  //   { ID: 'Online DMS', Name: "Online DMS", checked: false },
  //   { ID: 'Online WMS', Name: "Online WMS", checked: false },
  //   { ID: 'Maxsite', Name: "Maxsite", checked: false },
  //   { ID: 'Attendance Dashboard - maxops', Name: "Attendance Dashboard - maxops", checked: false },
  //   { ID: 'Geotagging - branch', Name: "Geotagging - branch", checked: false },
  //   { ID: 'Geotagging - Site', Name: "Geotagging - Site", checked: false },
  //   { ID: 'Self attendance - Maxops', Name: "Self attendance - Maxops", checked: false }
  // ]

  // coremodules = othermodule[0].modules[0].checked

  OtherModule = [
    {
      header: 'Core Modules',
      modules: [
        { ID: 'IsPaymax', Name: "Paymax", checked: false },
        { ID: 'Max Financial', Name: "Max Financial", checked: false },
        { ID: 'Compliance', Name: "Compliance", checked: false },
        { ID: 'Online DMS', Name: "Online DMS", checked: false },
        { ID: 'Web Ess', Name: "Web ESS", checked: false },
        { ID: 'Highlighter', Name: "ECR Highlighter", checked: false },
        { ID: 'Client Portal', Name: "Client Portal", checked: false },
        { ID: 'Maxsite', Name: "Site Management", checked: false },
        { ID: 'Online WMS', Name: "Online WMS", checked: false },
      ]
    },
    {
      header: 'MaxOps - Mobile',
      modules: [
        { ID: 'Online Registration', Name: "Online Registration", checked: false },
        { ID: 'Online Attendance', Name: "Online Attendance", checked: false },
        { ID: 'Attendance Dashboard', Name: "Attendance Dashboard", checked: false },
        { ID: 'Self Attendance', Name: "Self Attendance", checked: false },
        { ID: 'GeoTagging - branch', Name: "Branch GeoTagging", checked: false },
        { ID: 'GeoTagging - Site', Name: "Site GeoTagging", checked: false }
      ]
    },
  ];

  coreModules = {
    Paymax: { checked: false },
    MaxFinancial: { checked: false },
    Compliance: { checked: false },
    OnlineDMS: { checked: false },
    WebESS: { checked: false },
    ECRHighlighter: { checked: false },
    ClientPortal: { checked: false },
    SiteManagement: { checked: false },
    OnlineWMS: { checked: false },
  };

  maxopsMobile = {
    OnlineRegistration: { checked: false },
    OnlineAttendance: { checked: false },
    AttendanceDashboard: { checked: false },
    SelfAttendance: { checked: false },
    BranchGeoTagging: { checked: false },
    SiteGeoTagging: { checked: false }
  }

  Detail = {
    SelectType: 1,
    UserMasterId: 0,
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Designation: '',
    EmailID: '',
    Address: '',
    Phone: '',
    UserName: '',
    Password: '',
    ConfirmPassword: '',
    ProfileMasterId: null,
    userType_new: 'Administrator',
    MakerChecker: 'A',
    ApprovalUserType: null,
    IsUserApprovalFlag: '',
    IsSuperAdmin: false,
    FnFApprovalTypeId: 0,
    EmployeeMappingId: null as any,
    UserSignature: '' as any,
    IsPaymax: false,
    IsMaxFinancial: false,
    IsCompliance: false,
    IsHighlighter: false,
    IsOnlineDMS: false,
    IsOnlineRegistration: false,
    IsOnlineAttendance: false,
    IsWebESS: false,
    IsOnlineRNM: false,
    IsClientPortal: false,
    IsMaxsite: false,
    IsAttendanceDashboard: false,
    IsSiteGeoTagging: false,
    IsBranchGeoTagging: false,
    IsSelfAttendance: false,
    IsActive: true,
    SelectAll: false,
    SignatureUrl: '' as any,
    ESS_UserCompanyRights: [] as any,
    IsChangePassword: false,
    IsActiveBackend: false
  }

  ProfileLoad = [] as any;
  UserType: any = [{ Label: 'Administrator', Value: 'Administrator' }, { Label: 'User', Value: 'User' }];
  MakerCheckerOption: any = [{ Label: 'Maker', Value: 'M' }, { Label: 'Checker', Value: 'C' }, { Label: 'Approver', Value: 'A' }];
  CompanyMasterLoad: any[] = []
  ApprovalUserType = [{ l: 'A', v: 'A' }, { l: 'A1', v: 'A1' }, { l: 'A2', v: 'A2' }];
  FullnFinalApproval = [] as any;
  EmployeeMapping = [] as any;
  OtherModuleChunk: any[] = [];

  viewFile(type: string) {
    if (type === 'Signature') {
      window.open(this.Detail.SignatureUrl, '_blank');
    }
  }

  Validate(form: any) {
    if (form.valid) {
      this.Save();
    } else {
      form.valid = true;
    }
  }

  removeFile(type: string) {
    if (type === 'Signature') {
      this.Detail.UserSignature = null;
      this.Detail.SignatureUrl = null;
      const fileInput = document.getElementById('filedocimgSignature') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    }
  }

  upload(event: any, Folder: any, Tag = '') {
    try {
      if ((event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1])) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.UploadServices(Folder, reader.result, Tag, null, event.target.files[0].type.split('/')[1]);
          event.target.value = null;
        };
      } else {
        this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
        event.target.value = null;
      }
    } catch (e) { }
  }

  UploadServices(Folder: string, Base64: any, Tag = '', index = null, type = '') {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "") {
        this.Detail.UserSignature = response.FileName;
        this.Detail.SignatureUrl = response.Url;
      } else {
        this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  chunkOtherModule() {
    let chunkSize = 3;
    for (let i = 0; i < this.OtherModule.length; i += chunkSize) {
      this.OtherModuleChunk.push(this.OtherModule.slice(i, i + chunkSize));
    }
  }

  // onChange() {
  //   if (this.Detail.SelectAll) {
  //     this.OtherModule.forEach(item => item.checked = true)
  //   }
  //   else {
  //     this.OtherModule.forEach(item => item.checked = false)
  //   }
  // }

  InsertUpdate() {
    this.Detail.IsPaymax = this.coreModules.Paymax.checked;
    this.Detail.IsMaxFinancial = this.coreModules.MaxFinancial.checked;
    this.Detail.IsCompliance = this.coreModules.Compliance.checked;
    this.Detail.IsHighlighter = this.coreModules.ECRHighlighter.checked;
    this.Detail.IsOnlineDMS = this.coreModules.OnlineDMS.checked;
    this.Detail.IsOnlineRegistration = this.maxopsMobile.OnlineRegistration.checked;
    this.Detail.IsOnlineAttendance = this.maxopsMobile.OnlineAttendance.checked;
    this.Detail.IsWebESS = this.coreModules.WebESS.checked;
    this.Detail.IsOnlineRNM = this.coreModules.OnlineWMS.checked;
    this.Detail.IsClientPortal = this.coreModules.ClientPortal.checked;
    this.Detail.IsMaxsite = this.coreModules.SiteManagement.checked;
    this.Detail.IsAttendanceDashboard = this.maxopsMobile.AttendanceDashboard.checked;
    this.Detail.IsSiteGeoTagging = this.maxopsMobile.SiteGeoTagging.checked;
    this.Detail.IsBranchGeoTagging = this.maxopsMobile.BranchGeoTagging.checked;
    this.Detail.IsSelfAttendance = this.maxopsMobile.SelfAttendance.checked;

    this.Detail.EmployeeMappingId = this.Detail.EmployeeMappingId == null ? 0 : this.Detail.EmployeeMappingId;
    this.Detail.FnFApprovalTypeId = this.Detail.FnFApprovalTypeId == null ? 0 : this.Detail.FnFApprovalTypeId;

    const formattedCompany = this.CompanyMasterLoad.map(item => ({
      CompanyID: item.CompanyMasterID,
      IsSelected: item.IsSelected
    }))

    this.Detail.ESS_UserCompanyRights = formattedCompany;

    if (this.Detail.UserName.toLowerCase().trim() == 'admin' && this.Detail.UserMasterId == 0) {
      this.toast.show({ message: `Username cannot be ${this.Detail.UserName}`, type: toastTypeEnum.danger })
      return;
    }

    if (this.Detail.EmailID !== '') {
      if (!this.ValidateEmail(this.Detail.EmailID)) {
        this.toast.show({ message: 'Enter a valid email address', type: toastTypeEnum.danger })
        return;
      }
    }

    if (this.Detail.Password !== this.Detail.ConfirmPassword) {
      this.toast.show({ message: 'Password and confirm password should be same.', type: toastTypeEnum.danger })
      return;
    } else {
      if (this.common.CompanyParameterValue.RestrictSimplePassword) {
        if (!this.ValidatePassword(this.Detail.Password)) {
          this.toast.show({ message: 'Password must contain atleast one uppercase letter, one lowercase letter, one digit, one special character, minimum length of 8 characters', type: toastTypeEnum.warning })
          return;
        }
      }
    }

    const companySelected = this.CompanySelectionValidate();
    if (!companySelected) {
      this.toast.show({ message: 'Select atleast one company', type: toastTypeEnum.danger });
      return;
    }

    // if(this.Detail.Phone.length !== 10){
    //   this.toast.show({ message: 'Phone No should be of 10 digits', type: toastTypeEnum.danger });
    //   return;
    // }

    this.isDisabled = true;
    this.userMasterService.InsertUpdate(this.Detail).subscribe({
      next: (response) => {
        if (response) {
          if (response.Error_Code == "758" || response.Error_Code == "759") {
            this.isDisabled = false;
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              if (result) {
                this.router.navigate(['master/userdetail/usermaster']);
              }
            });
          }
          else {
            this.isDisabled = false;
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
          this.isDisabled = false;
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Save() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save ?'
    modalRef.result.then((result: any) => {
      if (result) {
        this.InsertUpdate();
      }
      // else {
      //   this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      // }
    }).catch(() => { });
  }

  // ComboLoad(Combotype: String) {
  //   this.comboload.ComboLoad({
  //     'Combotype': Combotype,
  //   }).subscribe({
  //     next: (response) => {
  //       if (Combotype == 'ProfileMaster') {
  //         this.ProfileLoad = response.ComboLoad;
  //       } else if (Combotype == 'EmpMapping') {
  //         this.EmployeeMapping = response.ComboLoad;
  //       } else if (Combotype == 'CompanyMaster') {
  //         this.CompanyMasterLoad = response.ComboLoad;
  //         this.CompanyMasterLoad.forEach(item => {
  //           item.IsSelected = false;
  //         })
  //         this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //           dtInstance.destroy();
  //           this.dtTrigger.next(null);
  //         });
  //       } else if (Combotype == 'FnFUserType') {
  //         this.FullnFinalApproval = response.ComboLoad;
  //       }
  //     },
  //     complete: () => {
  //     },
  //     error: (error) => {
  //     },
  //   });
  // }

  ComboLoadAsync(Combotype: string, Index = 0): Promise<any> {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.comboload.ComboLoad({
        'Combotype': Combotype,
      }).subscribe({
        next: (response) => {
          if (Combotype == 'ProfileMaster') {
            this.ProfileLoad = response.ComboLoad;
          } else if (Combotype == 'EmpMapping') {
            this.EmployeeMapping = response.ComboLoad;
          } else if (Combotype == 'CompanyMaster') {
            this.CompanyMasterLoad = response.ComboLoad;
            this.CompanyMasterLoad.forEach(item => {
              item.IsSelected = false;
            })
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          } else if (Combotype == 'FnFUserType') {
            this.FullnFinalApproval = response.ComboLoad;
          }
          this.isDisabled = false;
          resolve(true);
        },
        error: (err) => {
          this.isDisabled = false;
          reject(err);
        }
      });
    });
  }

  CompanySelectionValidate(): boolean {
    for (let i = 0; i < this.CompanyMasterLoad.length; i++) {
      if (this.CompanyMasterLoad[i].IsSelected) {
        return true;
      }
    }
    return false;
  }

  ValidatePassword(password: string) {
    const patternPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
    return patternPassword.test(password);
  }

  ValidateEmail(email: string) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  GetData() {
    this.isDisabled = true;
    this.userMasterService.GetData({
      SelectType: this.Detail.SelectType,
      UserMasterId: this.Detail.UserMasterId
    }).subscribe({
      next: (response) => {
        if (response) {
          const data = response.Table[0];
          this.Detail.FirstName = data.FirstName;
          this.Detail.MiddleName = data.MiddleName;
          this.Detail.LastName = data.LastName;
          this.Detail.Designation = data.Designation;
          this.Detail.EmailID = data.EmailID;
          this.Detail.Phone = data.Phone;
          this.Detail.Address = data.Address;
          this.Detail.IsActive = data.Active;
          this.Detail.IsActiveBackend = data.Active;
          this.Detail.IsSuperAdmin = data.IsSuperAdmin;
          this.Detail.IsUserApprovalFlag = data.IsUserApprovalFlag;
          this.Detail.userType_new = data.UserType.toLowerCase() == 'a' || data.UserType.toLowerCase() == 'administrator' ? 'Administrator' : 'User';
          this.Detail.MakerChecker = data.MakerChecker;
          this.Detail.UserName = data.UserName;
          // this.Detail.Password = data.Password;
          // this.Detail.ConfirmPassword = data.Password;
          this.Detail.ProfileMasterId = data.ProfileMasterId;
          this.Detail.ApprovalUserType = data.ApprovalUserType == '' ? null : data.ApprovalUserType;
          this.Detail.FnFApprovalTypeId = data.FnFUserType == 0 ? null : data.FnFUserType;
          this.Detail.EmployeeMappingId = data.EmpMappingID == 0 ? null : data.EmpMappingID;
          this.Detail.UserSignature = data.UserSignature;
          this.Detail.SignatureUrl = data.UserSignature == null || data.UserSignature == '' ? null : this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'Signature' + '/' + data.UserSignature;

          this.coreModules.Paymax.checked = data.IsPaymax
          this.coreModules.MaxFinancial.checked = data.ISMaxFinancial
          this.coreModules.Compliance.checked = data.IsOnlineCompliance
          this.coreModules.OnlineDMS.checked = data.IsOnlineDMS
          this.coreModules.WebESS.checked = data.IsWebESS
          this.coreModules.ECRHighlighter.checked = data.IsHighlighter
          this.coreModules.ClientPortal.checked = data.IsClientPortal
          this.coreModules.SiteManagement.checked = data.IsMaxsite
          this.coreModules.OnlineWMS.checked = data.IsOnlineRNM


          this.maxopsMobile.OnlineRegistration.checked = data.IsOnlineRegistration
          this.maxopsMobile.OnlineAttendance.checked = data.IsOnlineAttendance
          this.maxopsMobile.AttendanceDashboard.checked = data.IsAttendanceDashboard
          this.maxopsMobile.SelfAttendance.checked = data.IsSelfAttendance
          this.maxopsMobile.BranchGeoTagging.checked = data.IsBranchGeoTagging
          this.maxopsMobile.SiteGeoTagging.checked = data.IsSiteGeoTagging

          this.Detail.IsPaymax = data.IsPaymax;
          this.Detail.IsMaxFinancial = data.ISMaxFinancial;
          this.Detail.IsCompliance = data.IsOnlineCompliance;
          this.Detail.IsHighlighter = data.IsHighlighter;
          this.Detail.IsOnlineDMS = data.IsOnlineDMS;
          this.Detail.IsOnlineRegistration = data.IsOnlineRegistration;
          this.Detail.IsOnlineAttendance = data.IsOnlineAttendance;
          this.Detail.IsWebESS = data.IsWebESS;
          this.Detail.IsOnlineRNM = data.IsOnlineRNM;
          this.Detail.IsClientPortal = data.IsClientPortal;
          this.Detail.IsMaxsite = data.IsMaxsite;
          this.Detail.IsAttendanceDashboard = data.IsAttendanceDashboard;
          this.Detail.IsSiteGeoTagging = data.IsSiteGeoTagging;
          this.Detail.IsBranchGeoTagging = data.IsBranchGeoTagging;
          this.Detail.IsSelfAttendance = data.IsSelfAttendance;

          const companyRights = response.Table1;
          for (let i = 0; i < companyRights.length; i++) {
            const company = this.CompanyMasterLoad.find((e: any) => e.CompanyMasterID == companyRights[i].CompanyMasterId);
            if (company) {
              company.IsSelected = true;
            }
          }
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

}
